import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";

class EventtabController {
  constructor($http, $localStorage, $state) {
    this.name = "eventtab";
    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
  }

  goto_post_event_detail() {
    this.$state.go("posteventdetail");
  }

  goto_post_job_detail1() {
    this.$state.go("postjobdetail1");
  }

  goto_post_job_review() {
    this.$state.go("postjobreview");
  }
}

EventtabController.$inject = ["$http", "$localStorage", "$state"];

export default EventtabController;



// WEBPACK FOOTER //
// ./client/app/common/eventtab/eventtab.controller.js